export function ChevronLeftIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M13.39,16.06a1,1,0,0,0,0-1.42l0,0L8.77,10l4.62-4.62a1,1,0,0,0,0-1.42l0,0a1,1,0,0,0-1.41,0l0,0L6.61,9.28a1,1,0,0,0,0,1.41l0,0L12,16.06a1,1,0,0,0,1.41,0Z" />
    </svg>
  )
}
